import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Accordion } from 'src/design/molecules/Accordion';
import { TextInput } from 'src/design/atoms/TextInput';
import { IconLockFilled, IconLockOpen } from '@tabler/icons-react';
import React from 'react';
import { WorkflowStepDto } from 'src/api/FiretrolApiClient';
import { EditDrawer } from './EditDrawer';

export interface IWorkflowStepProps {
  step: WorkflowStepDto;
  stepKey: string;
  locked: boolean;
  onValueChange: (step: WorkflowStepDto) => void;
  onStepRemoved: () => void;
  isTemplateEditor: boolean;
  resourceId?: string;
  readOnly?: boolean;
}

/** @registry Collapsible card for a single workflow step, wrapping its label editor and EditDrawer settings. */
export const WorkflowStep: React.FC<IWorkflowStepProps> = ({
  step,
  stepKey,
  locked,
  onValueChange,
  onStepRemoved,
  isTemplateEditor,
  resourceId,
  readOnly = false,
}) => {
  const setNameValue = (val: string) => {
    const updated = {
      ...step,
      label: val,
    };
    onValueChange(updated);
  };

  return (
    <Paper withBorder p={0}>
      <Accordion variant="default" color="white">
        <Accordion.Item value={stepKey} style={{ border: 'none' }}>
          <Accordion.Control>
            <Group gap="xs" align="center" wrap="nowrap" mr="sm">
              {locked && (
                <IconLockFilled size={18} color="var(--mantine-color-gray-7)" />
              )}
              {!locked && (
                <IconLockOpen size={18} color="var(--mantine-color-gray-4" />
              )}
              <TextInput
                value={step.label}
                onChange={(e) => setNameValue(e.target.value)}
                flex={1}
                onClick={(e) => e.stopPropagation()}
                disabled={readOnly}
              />
            </Group>
          </Accordion.Control>
          <Accordion.Panel>
            <EditDrawer
              onValueChange={onValueChange}
              step={step}
              locked={locked}
              onStepRemoved={onStepRemoved}
              isTemplateEditor={isTemplateEditor}
              resourceId={resourceId}
              readOnly={readOnly}
            />
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Paper>
  );
};
